module.exports = __webpack_public_path__ + "_assets/img/coupon.e9d00334.svg";